import  {GET_LIST_OF_TABLES} from "../constants/actionTypes";
import * as api from "../api/index.js";

export const getListOfTables = (formData) => async (dispatch) => {
  try {
    const response = await api.getListOfTables(formData);
    const data = response?.data;

    // If 'tables' exists and is an array, it's a success
    if (Array.isArray(data?.tables)) {
      dispatch({
        type: GET_LIST_OF_TABLES,
        payload: data,
      });
    } else {
      // Error from backend - still dispatch to reset state
      dispatch({
        type: GET_LIST_OF_TABLES,
        payload: {
          tables: [],
          error: data?.detail || "Unknown error while fetching tables.",
        },
      });
    }
  } catch (error) {
    // Network or internal error
    dispatch({
      type: GET_LIST_OF_TABLES,
      payload: {
        tables: [],
        error: error.message || "Server/network error",
      },
    });
  }
};

